module.exports = __webpack_public_path__ + "img/brown-chat.cd375c00.svg";